import React, { useEffect, useState } from 'react';
import Navbar from './Navbar';
import Sidebar from './Sidebar';
import labService from './labService';
import authService from '../auth/authService';
import { getApiErrorMessage } from '../auth/apiError';
import './css/Contact.css';

const SEND_ERROR = 'Error sending message. Please try again.';
// The server's limit for the message (ContactFormSerializer).
const MESSAGE_MAX_LENGTH = 2000;

const Contact = ({ isCollapsed, toggleSidebar }) => {
  const [formData, setFormData] = useState({
    topic: 'Payments & Refunds',
    email: '',
    message: ''
  });
  const [statusMsg, setStatusMsg] = useState({ type: '', text: '' });
  const [loading, setLoading] = useState(false);

  const topics = [
    "Payments & Refunds",
    "Academic and Enterprise licenses",
    "Predictions & Models",
    "Other"
  ];

  useEffect(() => {
    if (!statusMsg.text) return;

    const timer = setTimeout(() => {
        setStatusMsg({ type: '', text: '' });
    }, 10000);

    return () => clearTimeout(timer);
    }, [statusMsg]);


  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
        await labService.contactUs(formData);

        setStatusMsg({
        type: 'success',
        text: 'Message has been sent successfully!'
        });

        // Reset form ONLY on success
        setFormData({
        topic: 'Payments & Refunds',
        email: '',
        message: ''
        });

    } catch (error) {
        setStatusMsg({
        type: 'error',
        // Only a network failure says more than the fixed sentence; server texts aren't for users.
        text: error.response ? SEND_ERROR : getApiErrorMessage(error, SEND_ERROR)
        });
    } finally {
        setLoading(false);
    }

  };


  return (
    <div className='lab-container'>
      <Navbar />
      <div className='lab-side-content'>
        <Sidebar active_n={1} isCollapsed={isCollapsed} toggleSidebar={toggleSidebar} />
        <div className='home-content'>
          <h2 className='aval-endp mar-usr-prof'>Contact us</h2>
          <p className='complete mar-usr-prof'>Please select desired topic from the dropdown menu and describe your problem.</p>

          <form onSubmit={handleSubmit} className='form-contact'>
            <div >
              <select 
                className="contact-dropdown"
                value={formData.topic}
                onChange={(e) => setFormData({...formData, topic: e.target.value})}
              >
                {topics.map(t => <option key={t} value={t}>{t}</option>)}
              </select>
            </div>

            <div >
              <input 
                type="email"
                required
                className="inp-contact-email"
                placeholder="email@example.com"
                value={formData.email}
                onChange={(e) => setFormData({...formData, email: e.target.value})}
              />
            </div>

            <div >
              <textarea 
                required
                className="area-contact-message"
                placeholder="Describe your issue here..."
                maxLength={MESSAGE_MAX_LENGTH}
                value={formData.message}
                onChange={(e) => setFormData({...formData, message: e.target.value})}
              />
            </div>

            <button 
              type="submit" 
              className="contact-send" 
              disabled={loading}
            >
              {loading ? 'Sending...' : 'Send'}
            </button>

            {statusMsg.text && (
                <p
                    style={{
                        marginTop: '16px',
                        fontSize: '26px',
                        textAlign: 'center',
                        color: statusMsg.type === 'success' ? '#1e8834' : '#bd5656'
                    }}
                    >
                    {statusMsg.text}
                </p>

            )}
          </form>
        </div>
      </div>
    </div>
  );
};

export default Contact;